<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488.5 177.6" v-on="$listeners">
        <g :fill="color">
            <path class="cls-1"
                d="M60.2,133.4H31a4.44,4.44,0,0,0-4.4,4.4v8.8A4.44,4.44,0,0,0,31,151H51.4a4.39,4.39,0,0,0,3.1-1.3l8.8-8.8A4.42,4.42,0,0,0,60.2,133.4Z"/>
            <path class="cls-1"
                d="M84.3,106.8H4.2A4.23,4.23,0,0,0,0,111v62.2a4.44,4.44,0,0,0,4.4,4.4h9.2a4.44,4.44,0,0,0,4.4-4.4V128.8a4.44,4.44,0,0,1,4.4-4.4h62a4.44,4.44,0,0,0,4.4-4.4v-8.8A4.53,4.53,0,0,0,84.3,106.8Z"/>
            <path class="cls-1"
                d="M182.2,106.8H101.8a4.23,4.23,0,0,0-4.2,4.2v62.4a4.23,4.23,0,0,0,4.2,4.2h9.6a4.23,4.23,0,0,0,4.2-4.2V128.6a4.23,4.23,0,0,1,4.2-4.2h20.9a4.18,4.18,0,0,1,3,7.1l-.6.6a4.23,4.23,0,0,1-3,1.2H128.4a4.23,4.23,0,0,0-4.2,4.2v9.2a4.23,4.23,0,0,0,4.2,4.2h18a4.23,4.23,0,0,0,3-1.2l35.8-35.8A4.18,4.18,0,0,0,182.2,106.8Z"/>
            <path class="cls-1"
                d="M279.8,106.8H199.4a4.23,4.23,0,0,0-4.2,4.2v9.2a4.23,4.23,0,0,0,4.2,4.2h71.2a4.23,4.23,0,0,0,3-1.2l9.2-9.2A4.22,4.22,0,0,0,279.8,106.8Z"/>
            <path class="cls-1"
                d="M288.6,160h-9.2a4.23,4.23,0,0,0-4.2,4.2v9.2a4.23,4.23,0,0,0,4.2,4.2h9.2a4.23,4.23,0,0,0,4.2-4.2v-9.2A4.16,4.16,0,0,0,288.6,160Z"/>
            <path class="cls-1"
                d="M383.4,123l-9.2,9.2a4.23,4.23,0,0,0-1.2,3v3.1a4.23,4.23,0,0,1-4.2,4.2h-3.1a4.23,4.23,0,0,0-3,1.2l-9.2,9.2a4.16,4.16,0,0,0,3,7.1h12.3a4.23,4.23,0,0,1,4.2,4.2v9.2a4.23,4.23,0,0,0,4.2,4.2h9.2a4.23,4.23,0,0,0,4.2-4.2V125.9A4.2,4.2,0,0,0,383.4,123Z"/>
            <path class="cls-1"
                d="M380.8,106.8H366.1a4.23,4.23,0,0,0-3,1.2l-62.4,62.4a4.16,4.16,0,0,0,3,7.1h14.7a4.23,4.23,0,0,0,3-1.2l62.4-62.4A4.18,4.18,0,0,0,380.8,106.8Z"/>
            <path class="cls-1"
                d="M412.9,106.8h-9.2a4.23,4.23,0,0,0-4.2,4.2v62.4a4.23,4.23,0,0,0,4.2,4.2h9.2a4.23,4.23,0,0,0,4.2-4.2V111A4.23,4.23,0,0,0,412.9,106.8Z"/>
            <path class="cls-1"
                d="M244.6,133.4h-9.2a4.23,4.23,0,0,0-4.2,4.2v35.8a4.23,4.23,0,0,0,4.2,4.2h9.2a4.23,4.23,0,0,0,4.2-4.2V137.6A4.23,4.23,0,0,0,244.6,133.4Z"/>
            <path class="cls-1"
                d="M470.6,0a17.74,17.74,0,0,0-16.2,25.1L421.7,53.2a22.49,22.49,0,0,0-13.2-4.4h-.3l-2.8-11.7a15.28,15.28,0,1,0-9.7,2.4l2.8,11.7a22.15,22.15,0,0,0-12.2,18.3l-19.5,3a17.81,17.81,0,1,0,1.5,9.8l19.5-3a22.3,22.3,0,0,0,20.7,14,22.59,22.59,0,0,0,11.8-3.4l17.1,17.2a18,18,0,0,0-2.2,8.6A17.8,17.8,0,1,0,453,97.9a17.34,17.34,0,0,0-8.5,2.2L427.4,82.9A21.87,21.87,0,0,0,430.9,71a21,21,0,0,0-2.6-10.3L461,32.6a17.77,17.77,0,0,0,27.5-14.9A18,18,0,0,0,470.6,0Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'Logo',
    props: {
        color: {
            type: String,
            default: '#0052cc'
        }
    }
}
</script>
